import common from './common';

const ADDRESS_SDK_ORG_IDS = [2000, 30000];

const SDK_NAME_MAP = {
  u2: 'U2Address',
  np: 'npAddress',
};

const getSdkInstance = (mainOrgId) => {
  const sdkType = common.isLexue(mainOrgId) ? 'np' : 'u2';
  const sdkName = SDK_NAME_MAP[sdkType];
  return window[sdkName];
};

export const isAddressSdkOrg = (mainOrgId) => ADDRESS_SDK_ORG_IDS.includes(Number(mainOrgId));

export const isAddressSdkUser = (mainOrgId, roleId) => isAddressSdkOrg(mainOrgId) && roleId == 3;

const setSdkZIndex = (zIndex) => {
  document.documentElement.style.setProperty('--u2-toast-z-index', zIndex);
  document.documentElement.style.setProperty('--u2-content-z-index', zIndex);
  document.documentElement.style.setProperty('--u2-mask-z-index', zIndex);
};

const createContainer = ({ renderId, style }) => {
  const container = document.createElement('div');
  container.style.cssText = style;
  container.id = renderId;
  document.getElementById('root').appendChild(container);
};

const removeContainer = (renderId) => {
  const element = document.getElementById(renderId);
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
};

export const openAddressSdk = ({
  mainOrgId,
  appId,
  relatedCode,
  isTest = false,
  item = null,
  scene,
  u2at,
  onSuccess,
  onClose,
  onError,
}) => {
  if (!mainOrgId || !appId || !relatedCode) {
    onError(new Error('地址SDK参数不完整'));
    return;
  }

  if (common.isMobile()) {
    const mobileAddressUrl = common.isLexue(mainOrgId)
      ? `${common.getLexueAddressUrl()}address`
      : `${common.getAddressUrl()}addressSubmit`;
    const params = new URLSearchParams({
      studentCode: relatedCode,
      appId,
      isResolution: 'false',
    });
    if (common.isLexue(mainOrgId) && u2at) {
      params.set('u2at', u2at);
    }
    if (scene === 'exchange' && item) {
      // 移动端兑换场景下不透传 imageUrl
      const { imageUrl, ...restItem } = item;
      const curItem = encodeURIComponent(JSON.stringify(restItem));
      const redirectUri = encodeURIComponent(`${window.location.href}&curItem=${curItem}`);
      params.set('external', 'true');
      params.set('redirect_uri', redirectUri);
      window.location.href = `${mobileAddressUrl}?${params.toString()}`;
      return;
    }
    window.location.replace(`${mobileAddressUrl}?${params.toString()}`);
    return;
  }

  try {
    const sdk = getSdkInstance(mainOrgId);
    if (!sdk || typeof sdk.init !== 'function') {
      throw new Error('地址SDK未加载');
    }

    const renderId = 'roomboxAddress';
    const isAddressPage = scene === 'addressPage';
    const style = isAddressPage
      ? 'width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 1000;'
      : 'width: 640px; height: 580px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10000;';
    const zIndex = isAddressPage ? 1001 : 10001;

    createContainer({ renderId, style });

    const closeSdk = () => {
      sdk.close();
      removeContainer(renderId);
    };

    const initOptions = {
      app_id: appId,
      renderId,
      studentCode: relatedCode,
      isTest,
      addressId: '',
      isResolution: false,
      isHeader: !isAddressPage,
      isFooter: true,
      showEdit: true,
      onlyShowList: isAddressPage,
      isMask: false,
      zIndex,
      maskClose: false,
      expiredCb: () => {
        console.log('expiredCb');
      },
      closeCb: () => {
        closeSdk();
        onClose();
      },
      successCb: (res) => {
        closeSdk();
        onSuccess(res);
      },
    };
    if (common.isLexue(mainOrgId) && u2at) {
      initOptions.u2at = u2at;
    }
    sdk.init(initOptions);

    setSdkZIndex(zIndex);
  } catch (err) {
    onError(err);
  }
};
